import React from "react";

const examSchedule = [
  { sno: 1, exam: "PAT-I (ALL CLASSES EXCLUDING 11TH)", month: "21ST APRIL TO 26TH APRIL, 2025" },
  { sno: 2, exam: "UT (X & XII) PT-I (11TH)", month: "21ST JULY TO 26TH JULY 2025" },
  { sno: 3, exam: "PAT-II (HALF YEARLY)", month: "11TH SEPTEMBER TO 24TH SEPTEMBER, 2025" },
  { sno: 4, exam: "PAT-III", month: "1ST DECEMBER TO 6TH DECEMBER, 2025" },
  { sno: 5, exam: "ANNUAL EXAMINATION", month: "19TH FEBRUARY 2026 TO 2ND MARCH, 2026" },
  { sno: 6, exam: "PB-I (CLASS 10TH & 12TH)", month: "1ST DECEMBER TO 6TH DECEMBER, 2025" },
  { sno: 7, exam: "PB-II (CLASS 10TH & 12TH)", month: "5TH JANUARY 2026 TO 10TH JANUARY, 2026" },
];

const ptmSchedule = [
  { sno: 1, date: "12TH JULY, 2025", subject: "PAT-I" },
  { sno: 2, date: "11TH OCTOBER, 2025", subject: "PAT-II (HALF YEARLY)" },
  { sno: 3, date: "13TH DECEMBER, 2025", subject: "GENERAL PROGRESS OF STUDENT" },
  { sno: 4, date: "3RD JANUARY, 2026", subject: "PAT-III AND PB-I" },
];

const holidayList = [
  { date: "10TH APRIL, 2025", holiday: "MAHAVEER JAYANTI" },
  { date: "14TH APRIL, 2025", holiday: "AMBEDKAR JAYANTI" },
  { date: "18TH APRIL, 2025", holiday: "GOOD FRIDAY" },
  { date: "16TH JUNE, 2025", holiday: "EID-UL-ADHA (BAKRID)" },
  { date: "7TH AUGUST, 2025", holiday: "RAKSHABANDHAN" },
  { date: "9TH AUGUST, 2025", holiday: "JANMASHTMI" },
  { date: "27TH SEPTEMBER, 2025", holiday: "GANESH ESTHAPNA" },
  { date: "5TH OCTOBER, 2025", holiday: "MILAD UN NABI" },
  { date: "6TH OCTOBER, 2025", holiday: "GANESH VISARJAN" },
  { date: "30TH OCTOBER TO 3RD NOVEMBER, 2025", holiday: "DUSSEHRA VACATION" },
  { date: "18TH TO 22ND NOVEMBER, 2025", holiday: "DIWALI VACATION" },
  { date: "25TH NOVEMBER, 2025", holiday: "GURUNANAK JAYANTI" },
  { date: "24TH DECEMBER TO 31ST DECEMBER, 2025", holiday: "WINTER VACATION" },
  { date: "1ST JANUARY, 2026", holiday: "NEW YEAR" },
  { date: "4TH MARCH, 2026", holiday: "HOLI" },
  { date: "21ST MARCH, 2026", holiday: "RAMZAN ID/EID-UL-FITAR" },
  { date: "26TH MARCH, 2026", holiday: "RAMA NAVAMI" }
];

export default function AcademicCalendar() {
  return (
  //   <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg">
  //     <h1 className="text-2xl font-bold text-center mb-4">Academic Calendar 2025-2026</h1>
      

  //     <div className="mb-6">
  //       <p className="mb-2 font-medium">
  //         The Summer Break will commence on <strong>1st May 2025</strong> and will end on <strong>15th June 2025</strong>.<br/>
  //         School will reopen on <strong>16th June 2025</strong>.
  //       </p>
  //       <p className="mb-2">School result: <strong>19TH MARCH, 2026</strong></p>
  //       <p className="mb-2">New Session begins (Class 1st to 9th, X & XII): <strong>1st APRIL, 2026</strong></p>
  //       <p className="mb-2">New Session begins (Class NUR to SR.KG): <strong>23RD DECEMBER, 2025</strong></p>
  //     </div>

  //     <h3 className="text-lg font-bold mb-2">Exam Schedule</h3>
  //     <table className="w-full border border-black border-collapse mb-6">
  //       <thead className="bg-gray-200">
  //         <tr>
  //           <th className="border border-black px-4 py-2">S.No</th>
  //           <th className="border border-black px-4 py-2">Exam</th>
  //           <th className="border border-black px-4 py-2">Date</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {examSchedule.map((exam, index) => (
  //           <tr key={index}>
  //             <td className="border border-black px-4 py-2">{exam.sno}</td>
  //             <td className="border border-black px-4 py-2">{exam.exam}</td>
  //             <td className="border border-black px-4 py-2">{exam.month}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>

  //     <h3 className="text-lg font-bold mb-2">Parent-Teacher Meetings (PTM)</h3>
  //     <table className="w-full border border-black border-collapse mb-6">
  //       <thead className="bg-gray-200">
  //         <tr>
  //           <th className="border border-black px-4 py-2">S.No</th>
  //           <th className="border border-black px-4 py-2">Date</th>
  //           <th className="border border-black px-4 py-2">Subject</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {ptmSchedule.map((ptm, index) => (
  //           <tr key={index}>
  //             <td className="border border-black px-4 py-2">{ptm.sno}</td>
  //             <td className="border border-black px-4 py-2">{ptm.date}</td>
  //             <td className="border border-black px-4 py-2">{ptm.subject}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>

  //     <h3 className="text-lg font-bold mb-2">Holiday List</h3>
  //     <table className="w-full border border-black border-collapse">
  //       <thead className="bg-gray-200">
  //         <tr>
  //           <th className="border border-black px-4 py-2">Date</th>
  //           <th className="border border-black px-4 py-2">Holiday</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {holidayList.map((holiday, index) => (
  //           <tr key={index}>
  //             <td className="border border-black px-4 py-2">{holiday.date}</td>
  //             <td className="border border-black px-4 py-2">{holiday.holiday}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </table>
  //   </div>
  // );

    <div style={{ padding: '20px' }}>
      <h1 className="text-2xl font-bold text-center mb-4">Academic Calender 2025-26</h1>
      <p className="text-center mt-4">
        <a
          href="/documents/Academic_Calander.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xl font-bold text-purple-700 underline hover:text-purple-900"
        >
          CLICK HERE TO SEE ACADEMIC CALENDER 2025-26
        </a>
      </p>
    </div>
  );
}
